module.exports = __webpack_public_path__ + "img/calendar.1e89fa3a.svg";